import styled from "styled-components/native";

const Form = styled.View`
width: 80%;
max-width: 600px;
margin-top: 50px;
`

export default Form
